import classNames from 'classnames';
import { Spin } from 'antd';
import './buttonLoading.scss';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import type { ButtonLoadingProps } from './types';
import { useButtonLoading } from './useButtonLoading';

/**
 * Inline loading spinner with an optional label, rendered filled or plain. Applies the useButtonLoading side effect for the given props and renders an antd Spin with a rotating three-quarters indicator coloured white when isFilled and teal otherwise.
 *
 * @param props - Spinner id, class name, title and the isFilled variant flag.
 * @returns The spinner markup with its optional title.
 */
const ButtonLoading = (props: ButtonLoadingProps) => {
  const { className = undefined, isFilled = false, title = undefined, id = undefined } = props;

  useButtonLoading(props);

  return (
    <div className="button-loading-spinner flex" id={id}>
      <Spin
        className={classNames(isFilled ? '--filled' : '', className)}
        indicator={
          <Loading3QuartersOutlined spin style={{ color: isFilled ? '#ffffff' : '#0d9e92' }} />
        }
      />
      {title && <span>{title}</span>}
    </div>
  );
};

export default ButtonLoading;
